
import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { setAuthenticationName } from '../../../utilities/authentication/authenticationSlice';

export const needsToSignCollaboration = createAsyncThunk('selfCarePage/needsToSignCollaboration', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('needsToSignCollaboration', [data.subscriber]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return { Body: { IsSuccess: false } };
  }
});

export const ChangeSubscriberDetails = createAsyncThunk('selfCarePage/ChangeSubscriberDetails', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('ChangeClientName', [
      data.orgId ? data.orgId : '',
      data.selectedNumber,
      data.newFirstName,
      data.newLastName,
      data.isThirdPartySign,
      data.updatePrivateSubscriber
    ]);
    const loginData = thunkAPI.getState().authentication.loginData;
    if (loginData.isOtpAuthenticated) {
      thunkAPI.dispatch(setAuthenticationName({ firstName: data.newFirstName, lastName: data.newLastName }));
    }
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
